const variables = {
  primaryColors: {
    main: '#01372c',
    contrastText: '#fffcfc',
  },
  secondaryColors: {
    main: '#dfd4ee',
    contrastText: '#333037',
  },
  mainFont: '\'Montserrat\', sans-serif',
  raleway: '\'Raleway\', sans-serif',
  patientCardBgColor: '#dcf6ff',
  titleFontColor: '#494949',
  darkFontColor: '#17201E',
  curentFontColor: '#414141',
  lightFontColor: '#757575',
  lightIconColor: '#D2D2D2',
  backgroundLightColor: '#F0F3F2',
  outlinedColor: '#8a8a8a',
  warningColor: '#ff4c4c',
  inputBorderColor: '#DDDDDD',
  inputBorderRadius: '3px',
  inputPadding: '10px',
  white: '#FFF',
  black: '#000',
  bgImageGradient: 'linear-gradient(to bottom, #000000, #0f0f0f, #191919, #222122, #2b2a2b, #323132, #3a383a, #414042, #49484a, #515051, #595959, #616161)',
  breakpoint: {
    xs: '@media screen and (min-width: 375px)',
    sm: '@media screen and (min-width: 576px)',
    md: '@media screen and (min-width: 768px)',
    lg: '@media screen and (min-width: 992px)',
    xl: '@media screen and (min-width: 1400px)',
    xxl: '@media screen and (min-width: 1440px)',
  },
};

const theme = {
  app: {
    ...variables,
  },
};

export default theme;
